import React from "react";
import PropTypes from "prop-types";
import { Button, Col, Modal, ModalBody, ModalFooter, Row } from "reactstrap";
import styled from "styled-components";
import "flatpickr/dist/themes/material_blue.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
import CustomPlanItem from "./CustomPlanItem";
import SimpleLoader from "../../../../../components/SimpleLoader/index";
import { id } from "date-fns/locale";
import CustomMiniLoader from "../../../../../components/CustomMiniLoader/CustomMiniLoader";
import CustomSelect from "../../../../../components/Common/CustomSelect";
import { showInfoMessage } from "../../../../../helpers/utils";

const EditCustomPlanModal = ({
  isOpen,
  toggle,
  editData,
  permissions,
  currentMonth,
  getCustomProfitByDays,
  setCustomProfitByDays,
  addCustomProfitByDays,
  updateCustomProfitByDays,
  loader,
  data,
  account_managers,
  updateCustomProfit,
}) => {
  const [isFormSubmit, setIsFormSubmit] = React.useState(false);

  const generateKey = () => Math.round(Math.random() * 10000).toString();
  const [groups, setGroups] = React.useState([]);
  const [selectedManager, setSelectedManager] = React.useState();
  const [selectedSalesManager, setSelectedSalesManager] = React.useState();

  const handleAddGroup = () => {
    if (groups.length <= 30) {
      setGroups(prev => [
        ...prev,
        {
          id: "",
          key: generateKey(),
          cashback_id: "",
          payment: "",
          spend: "",
          date: "",
          cashback: "",
        },
      ]);
    } else {
      showInfoMessage("Added max fields");
    }
  };

  const handleDeleteGroup = key => {
    setGroups(prev => prev.filter(i => i.key !== key));
  };

  const handleGetData = () => {
    const date = {
      date_from: currentMonth.start_date,
      date_to: currentMonth.end_date,
    };

    return getCustomProfitByDays({
      ...date,
      main: editData.id,
    });
  };

  React.useEffect(() => {
    handleGetData();
    setSelectedManager({
      value: editData?.manager_id,
      label: editData?.manager,
    })
    
    if (editData?.sales_manager) {
      setSelectedSalesManager({
        value: editData?.sales_manager_id,
        label: editData?.sales_manager,
      })
    } else {
      setSelectedSalesManager({
        value: null,
        label: 'None',
      })
    }

    return () => {
      setCustomProfitByDays([]);
      setGroups([]);
      setSelectedManager([])
      setSelectedSalesManager([])
    };
  }, []);

  const onCloseToggle = React.useMemo(() => {
    if (loader) return toggle();
  }, [loader]);

  React.useEffect(() => {
    if (data.length > 0) {
      let customs = [];
      // payment = income,
      // cost = spend,
      data.map(i => {
        customs.push({
          cashback_id: i.cashback?.id,
          key: generateKey(),
          cashback: i.cashback?.value,
          payment: i.payment,
          spend: i.spend,
          date: i.date,
          id: i.id,
        });
      });
      setGroups(customs);
    }
  }, [data]);

  const onSubmit = (e, errors, params) => {
    setIsFormSubmit(true);
    if (errors?.length === 0) {
      const items = {
        items: [],
        patch: [],
        add: [],
        drop: [],
        cashback: {
          add: [],
          patch: [],
          drop: [],
        },
      };


      updateCustomProfit({
        id: editData.id,
        name: params.name,
        plan: params.plan,
        corrected_plan: params.corrected_plan,
        account_manager: params.account_manager.value,
        sales_manager: params?.sales_manager_id.value,
      });

      if (groups.length > 0) {
        for (const key in params) {
          const split = key.split("|");
          if (split.length === 2) {
            const k = split[0];
            let suffix = items.items.find(i => i.key === split[1])?.key;
            if (suffix !== undefined) {
              let idx = items.items.findIndex(i => i.key === suffix);
              items.items[idx][k] = params[key];
            } else {
              items.items.push({
                key: split[1],
                [k]: params[key],
              });
            }
          }
        }

        if (data.length > 0) {
          items.items.map(i => {
            data.map(current => {
              let find = items.items.findIndex(i => i.id == current.id);
              if (find < 0) {
                items.drop.push(current.id);
                current.cashback?.id &&
                  items.cashback.drop.push(current.cashback?.id);
              }
            });

            if (i?.id) {
              items.patch.push({
                id: i.id,
                date: i.date,
                payment: i.payment,
                spend: i.spend,
                profit: (i.payment - i.spend).toFixed(2),
              });
              items.cashback.patch.push({
                id: i.cashback_id,
                cashback: i.cashback,
                plan_id: i.id,
                plan_type: "custom",
              });
            } else {
              items.add.push({
                date: i.date,
                payment: i.payment,
                spend: i.spend,
                profit: (i.payment - i.spend).toFixed(2),
                main: editData.id,
              });
              items.cashback.add.push({
                cashback: i.cashback,
                plan_id: i.id,
                plan_type: "custom",
              });
            }
          });
          updateCustomProfitByDays(items);
        } else {
          items.items.map(i => {
            items.add.push({
              date: i.date,
              payment: i.payment,
              spend: i.spend,
              profit: (i.payment - i.spend).toFixed(2),
              main: editData.id,
            });
            items.cashback.add.push({
              cashback: i.cashback,
              plan_type: "custom",
            });
          });

          addCustomProfitByDays({
            plan: items.add,
            cashback: items.cashback.add,
          });
        }
      } else {
        data.map(current => {
          let find = items.items.findIndex(i => i.id == current.id);
          if (find < 0) {
            items.drop.push(current.id);
            current.cashback?.id &&
              items.cashback.drop.push(current.cashback?.id);
          }
          updateCustomProfitByDays(items);
        });
        toggle();
      }
    }
  };

  return (
    <ModalStyle
      isOpen={isOpen}
      autoFocus={true}
      centered={true}
      size="lg"
      toggle={toggle}
    >
      {() => onCloseToggle()}
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          Edit {editData?.name || editData?.group_name}
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={onSubmit}>
        <ModalBody>
          {/* {loader ? (
            <SimpleLoader />
          ) : ( */}
          <Row>
            <Col md={12}>
              <Row className="row-with-sticky">
                <Row>
                  <Col sm={4} className="mt-1 mb-1">
                    <label htmlFor="">Name:</label>
                    <AvField
                      name={`name`}
                      placeholder="Name..."
                      type="text"
                      defaultValue={editData?.name || editData?.group_name}
                      className="form-control"
                      value={""}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Please, enter a name",
                        },
                      }}
                    />
                  </Col>
                  <Col sm={4} className="mt-1 mb-1">
                    <label htmlFor="">Sales Manager:</label>
                    <CustomSelect
                      name="sales_manager_id"
                      options={[ { label: 'None', value: null }, ...account_managers]}
                      placeholder="Sales manager..."
                      defaultValue={selectedSalesManager || ""}
                      onChange={setSelectedSalesManager}
                      isFormSubmit={isFormSubmit}
                      classNamePrefix="select2-selection"
                    />
                  </Col>
                </Row>
                <Col sm={4} className="mt-1 mb-1">
                  <label htmlFor="">Project Manager:</label>
                  <CustomSelect
                    name="account_manager"
                    options={account_managers}
                    placeholder="Manager..."
                    // defaultValue={
                    //   editData?.manager_id
                    //     ? {
                    //         value: editData?.manager_id,
                    //         label: editData?.manager,
                    //       }
                    //     : ""
                    // }
                    defaultValue={selectedManager || ""}
                    onChange={setSelectedManager}
                    isFormSubmit={isFormSubmit}
                    // onChange={a =>
                    //   handleChangeForm(row?.edit_id, "account_manager", a)
                    // }
                    classNamePrefix="select2-selection"
                    required
                  />
                </Col>
                <Col sm={4} className="mt-1 mb-1">
                  <label htmlFor="">Plan:</label>
                  <AvField
                    name="plan"
                    type="number"
                    placeholder="Planned sum..."
                    defaultValue={editData?.plan}
                    // onChange={e =>
                    //   handleChangeForm(row?.edit_id, "plan", e.target.value)
                    // }
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Please, enter a plan",
                      },
                    }}
                  />
                </Col>
                <Col sm={4} className="mt-1 mb-1">
                  <label htmlFor="">Corrected plan:</label>
                  <AvField
                    name="corrected_plan"
                    type="number"
                    placeholder="Corrected plan..."
                    defaultValue={editData?.corrected_plan}
                    // defaultValue={row?.corrected_plan}
                    // onChange={e =>
                    //   handleChangeForm(
                    //     row?.edit_id,
                    //     "corrected_plan",
                    //     e.target.value
                    //   )
                    // }
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Please, enter a corrected plan",
                      },
                    }}
                  />
                </Col>
                {/* <Col sm={4} className="mt-1 mb-1">
                  <label htmlFor="">Income:</label>
                  <AvField
                    name="payment"
                    type="number"
                    placeholder="Income..."
                    // defaultValue={row?.payment}
                    // onChange={e =>
                    //   handleChangeForm(row?.edit_id, "payment", e.target.value)
                    // }
                  />
                </Col>
                <Col sm={4} className="mt-1 mb-1">
                  <label htmlFor="">Cost:</label>
                  <AvField
                    name="spend"
                    type="number"
                    placeholder="Cost..."
                    // defaultValue={row?.spend}
                    // onChange={e =>
                    //   handleChangeForm(row?.edit_id, "spend", e.target.value)
                    // }
                  />
                </Col> */}
                <Row className="m-0">
                  <div className="text-end p-0 mb-3 mt-3">
                    <Button color="primary" onClick={handleAddGroup}>
                      <i className="mdi mdi-plus" /> Add profit
                    </Button>
                  </div>
                </Row>
              </Row>
              <StyledScroll params={groups.length}>
                {groups.length > 0 ? (
                  groups.map((i, idx) => (
                    <CustomPlanItem
                      key={idx}
                      num={groups.length}
                      keys={i.key}
                      items={i}
                      onDelete={() => handleDeleteGroup(i.key)}
                    />
                  ))
                ) : (
                  <Row className="align-items-center text-center mt-4">
                    <Col xs={12}>
                      <i
                        className="dripicons-archive"
                        style={{ fontSize: "40px", opacity: "0.2" }}
                      />
                      <p style={{ opacity: "0.2" }}>Empty...</p>
                    </Col>
                  </Row>
                )}
              </StyledScroll>
            </Col>
          </Row>
          {/* )} */}
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <Button
                  color="primary"
                  style={{
                    padding: "10px",
                    minWidth: "74px",
                    marginRight: 10,
                    display: loader ? "none" : "",
                  }}
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                >
                  Close
                </Button>
                {permissions?.["change_managerplanmodel"] && (
                  <>
                    {loader ? (
                      <CustomMiniLoader
                        style={{ padding: "10px", minWidth: "143px" }}
                        status
                        text="Please wait"
                      />
                    ) : (
                      <Button
                        color="success"
                        style={{ padding: "10px", minWidth: "143px" }}
                      >
                        Save changes
                      </Button>
                    )}
                  </>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </ModalStyle>
  );
};

const ModalStyle = styled(Modal)`
  position: relative;

  .modal-header {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
  }

  .row-with-sticky {
    position: sticky;
    top: 61px;
    background: #fff;
    z-index: 1;
    border-bottom: 1px solid #eff2f7;
    margin: 0 0 20px 0;
  }
`;

const StyledScroll = styled.div`
  /* max-height: 490px; */
  /* overflow-y: ${({ params }) => (params > 3 ? "auto" : "")}; */

  @media (max-width: 768px) {
    /* overflow-y: ${({ params }) => (params >= 2 ? "auto" : "")}; */
  }
`;

EditCustomPlanModal.propTypes = {
  editData: PropTypes.any,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  permissions: PropTypes.object.isRequired,
  getCustomProfitByDays: PropTypes.func.isRequired,
  data: PropTypes.any,
  currentMonth: PropTypes.object,
  loader: PropTypes.bool,
  setCustomProfitByDays: PropTypes.func.isRequired,
  updateCustomProfitByDays: PropTypes.func.isRequired,
  addCustomProfitByDays: PropTypes.func.isRequired,
  account_managers: PropTypes.any.isRequired,
  updateCustomProfit: PropTypes.func.isRequired,
};

export default EditCustomPlanModal;
